import { DataSourceSummary } from "../../data-source/state/union.model";
import { Model, ModelVersion } from "../../models/state/model";

// These describe the URL query param key used for setting a specific context
export enum ContextKey {
  DataSourceContextKey = "ds",
  SentimentContextKey = "s",
  TopicContextKey = "t",
  EmotionContextKey = "e",
  IntentContextKey = "i",
  CategoryContextKey = "c",
  Focused = "f",
}

// This interface describes the URL Query Params object used for managing context
// through navigation
export interface ContextParams {
  [ContextKey.DataSourceContextKey]?: string; // Data Source UUID
  [ContextKey.SentimentContextKey]?: string; // Sentiment Model Version UUID
  [ContextKey.TopicContextKey]?: string; // Topic Model Version UUID
  [ContextKey.EmotionContextKey]?: string; // Emotion Model Version UUID
  [ContextKey.IntentContextKey]?: string; // Intent Model Version UUID
  [ContextKey.CategoryContextKey]?: string; // Category Model Version UUID
  [ContextKey.Focused]?: string;
}

export interface ModelContext {
  model: Model;
  version: ModelVersion;
  readOnly: boolean;
}

export interface Context {
  [ContextKey.DataSourceContextKey]?: DataSourceSummary;
  [ContextKey.SentimentContextKey]?: ModelContext;
  [ContextKey.TopicContextKey]?: ModelContext;
  [ContextKey.EmotionContextKey]?: ModelContext;
  [ContextKey.IntentContextKey]?: ModelContext;
  [ContextKey.CategoryContextKey]?: ModelContext;
}

export interface ModelOption extends Model {
  applied: boolean;
}

export interface ModelVersionWithApplied extends ModelVersion {
  applied: boolean;
}

export interface ModelsWithVersions {
  models: ModelOption[];
  versionsForModels: {
    [modelID: string]: ModelVersionWithApplied[];
  };
  focusedVersions: ModelVersionWithApplied[];
}

export interface ModelAndVersionOptions {
  sentiment: ModelsWithVersions;
  topic: ModelsWithVersions;
  emotion: ModelsWithVersions;
  intent: ModelsWithVersions;
  category: ModelsWithVersions;
}
